import { isInteger, toNumber } from 'lodash';

import { BetSides } from 'constants/myBets';
import useBetLabels from 'hooks/useBetLabels';
import { useMarketUnits } from 'hooks/useMarketUnits';
import { THandicap, TPrice, TSize } from 'types/bets';
import { WhatIfValueClasses } from 'types/betslip';
import { TMarketLineRangeInfo } from 'types/markets';
import { BetSide } from 'types/myBets';
import { getCalculatedParams } from 'utils/betLabels';

import BetLabelsTpl from '../BetLabelsTpl';

type LineLabelProps = {
  price: TPrice;
  size: TSize;
  handicap?: THandicap | null;
  betType: BetSide;
  eventTypeId?: string;
  lineRangeInfo: TMarketLineRangeInfo | null;
  currency?: string;
  className?: string;
  emptyValue?: string;
  valueClasses?: WhatIfValueClasses;
};

const LineLabel = ({
  price,
  size,
  betType,
  lineRangeInfo,
  currency,
  className = '',
  emptyValue = '',
  valueClasses
}: LineLabelProps) => {
  const marketUnitTranslated = useMarketUnits(lineRangeInfo?.marketUnit ?? 'points', toNumber(price || 0));
  const { getLineLabels } = useBetLabels();

  const { odds, stake } = getCalculatedParams({ price, size, betType });

  const rangeInfoStep = lineRangeInfo?.interval || 1;

  const { labelW, labelS, labelL } = getLineLabels(odds, rangeInfoStep, marketUnitTranslated);

  const profitLossW = price && size ? (betType === BetSides.Back ? -1 * stake : stake) : null;
  const profitLossS = !isInteger(rangeInfoStep) && odds && stake ? 0 : null;
  const profitLossL = price && size ? (betType === BetSides.Back ? stake : -1 * stake) : null;

  return (
    <BetLabelsTpl
      betType={betType}
      labelW={labelW}
      labelS={labelS}
      labelL={labelL}
      profitLossW={profitLossW}
      profitLossS={profitLossS}
      profitLossL={profitLossL}
      currency={currency}
      className={className}
      emptyValue={emptyValue}
      valueClasses={valueClasses}
    />
  );
};

export default LineLabel;
